import { defineMessages } from 'react-intl';

const messages: {
	sourcesButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sourcesButtonLabel: {
		id: 'rovo-for-you.sources.sources-button-label',
		defaultMessage: 'Show sources',
		description: 'Label for the sources button which opens the sources popup when clicked',
	},
});

export default messages;
